// utils/api.js
import axios from "axios";
// http://localhost:3000/api/v1
// https://api.uneeva-gmbh.de/api/v1
const API = axios.create({
  baseURL: "https://api.uneeva-gmbh.de/api/v1", // or your backend URL
  withCredentials: true, // optional if you're using cookies/sessions
});

export default API;
export const BASE_URL = "https://api.uneeva-gmbh.de";
